import * as x from '../helpers/xmlHelpers';

import { AnalyzedProperties } from './analyzedProperties';
import { ComparableMultipliers } from './comparableMultipliers';
import { ComparableProperties } from './comparableProperties';
import { ComparableRentals } from './comparableRentals';
import { DataSources } from './dataSources';
import { SubjectProperty } from './subjectProperty';
import { ValuationReport } from './valuationReport';

export class ValuationAnalysis {
    constructor(doc) {
        this.allImages = [];
        this.subjectProperty = null;
        this.salesComparables = null;
        this.landComparables = null;
        this.rentalComparables = null;
        this.multiplierComparables = null;
        this.analyzedProperties = null;
        this.valuationReport = null;
        this.dataSources = null;

        var node;
        var nodes;

        node = x.selectSingleNode(doc, "ns:PROPERTIES/ns:PROPERTY[@ValuationUseType = 'SubjectProperty']");
        if (node)
            this.subjectProperty = new SubjectProperty(node);

        nodes = x.selectNodes(doc, "ns:PROPERTIES/ns:PROPERTY[@ValuationUseType='SalesComparable']");
        if (nodes)
            this.salesComparables = new ComparableProperties(nodes);

        nodes = x.selectNodes(doc, "ns:PROPERTIES/ns:PROPERTY[@ValuationUseType='LandComparable']");
        if (nodes)
            this.landComparables = new ComparableProperties(nodes);

        nodes = x.selectNodes(doc, "ns:PROPERTIES/ns:PROPERTY[@ValuationUseType='RentalComparable']");
        if (nodes)
            this.rentalComparables = new ComparableRentals(nodes);

        nodes = x.selectNodes(doc, "ns:PROPERTIES/ns:PROPERTY[@ValuationUseType='GrossRentMultiplierComparable']");
        if (nodes)
            this.multiplierComparables = new ComparableMultipliers(nodes);

        nodes = x.selectNodes(doc, "ns:PROPERTIES/ns:PROPERTY[@ValuationUseType='PropertyAnalyzedNotUsed']");
        if (nodes)
            this.analyzedProperties = new AnalyzedProperties(nodes);

        node = x.selectSingleNode(doc, "./ns:VALUATION_REPORT");
        if (node)
            this.valuationReport = new ValuationReport(node);

        node = x.selectSingleNode(doc, "./ns:DATA_SOURCES");
        if (node)
            this.dataSources = new DataSources(node);

    }

    // Check if any private water access in subject or comps
    GetPrivateWaterAccess() {
        // Check subject property
        if (this.subjectProperty?.site?.siteInfluences) {
            for (const si of this.subjectProperty.site.siteInfluences) {
                if (si.bodiesOfWater?.bodiesOfWaterList) {
                    for (const bow of si.bodiesOfWater.bodiesOfWaterList) {
                        if (bow.privateAccessIndicator) return true;
                    }
                }
            }
        }

        // Check comparable properties
        if (this.salesComparables?.comparablePropertyList) {
            for (const cp of this.salesComparables.comparablePropertyList) {
                if (cp.site?.siteInfluences) {
                    for (const si of cp.site.siteInfluences) {
                        if (si.bodiesOfWater?.bodiesOfWaterList) {
                            for (const bow of si.bodiesOfWater.bodiesOfWaterList) {
                                if (bow.privateAccessIndicator) return true;
                            }
                        }
                    }
                }
            }
        }

        return false;
    }

    // Check if there are any waterfront features
    GetHasWaterfrontFeatures() {
        if (this.subjectProperty?.site?.siteInfluences) {
            for (const si of this.subjectProperty.site.siteInfluences) {
                if (si.siteInfluenceDetail?.waterfrontDevelopmentRightsIndicator) {
                    return true;
                }
            }
        }

        if (this.salesComparables?.comparablePropertyList) {
            for (const cp of this.salesComparables.comparablePropertyList) {
                if (cp.site?.siteInfluences) {
                    for (const si of cp.site.siteInfluences) {
                        if (si.siteInfluenceDetail?.waterfrontDevelopmentRightsIndicator) {
                            return true;
                        }
                    }
                }
            }
        }

        return false;
    }

    ADUsExist() {
        // Check SubjectProperty improvements
        for (const i of this.subjectProperty.improvements.improvementList) {
            for (const pu of i.propertyUnits) {
                if (pu.propertyUnitDetail?.accessoryDwellingUnitIndicator ?? false) {
                    return true;
                }
            }
        }

        // Check ComparableProperty improvements
        for (const cp of this.salesComparables.comparablePropertyList) {
            for (const i of cp.improvements.improvementList) {
                if (i.propertyUnits !== null) {
                    for (const pu of i.propertyUnits) {
                        if (pu.propertyUnitDetail?.accessoryDwellingUnitIndicator ?? false) {
                            return true;
                        }
                    }
                }
            }
        }

        return false;
    }

    GetOubuildingsList(index) {
        const list = [];
        list.push(this.subjectProperty.GetOutbuilding(index));

        for (const cp of this.salesComparables.comparablePropertyList) {
            list.push(cp.GetOutbuilding(index));
        }

        return list;
    }

    GetMaxSubjOutbuildings() {
        let maxOutbuildings = 0;

        for (const i of this.subjectProperty.improvements.improvementList) {
            if (i.improvementDetail.improvementType === "Outbuilding") {
                if (i.improvementDetail.outbuildingType !== "StandaloneADU") {
                    maxOutbuildings++;
                }
            }
        }

        return maxOutbuildings;
    }

    GetMaxCompOutbuildings() {
        let maxOutbuildings = 0;

        for (const cp of this.salesComparables.comparablePropertyList) {
            let count = 0;

            for (const i of cp.improvements.improvementList) {
                if (i.improvementDetail.improvementType === "Outbuilding") {
                    if (i.outbuildingType !== "StandaloneADU") {
                        count++;
                    }
                }
            }

            if (count > maxOutbuildings) {
                maxOutbuildings = count;
            }
        }

        return maxOutbuildings;
    }

    GetMaxOutbuildings() {
        var maxSubOut = this.GetMaxSubjOutbuildings();
        var maxCompOut = this.GetMaxCompOutbuildings();
        var maxOut = (maxSubOut > maxCompOut) ? maxSubOut : maxCompOut;
        return maxOut;
    }

	GetIndicatedValueBySalesComparisonApproach() {
		return this.valuationReport.approachToValue.salesComparisonApproach.salesComparisonApproachDetail.valueIndicatedBySalesComparisonAmount;
	}
 
}

